import React, {Component} from 'react';
import { Link } from "react-router-dom";

class Header extends Component {
    render() {
        return !window.location.pathname.includes("cardanotrees") && (
            <header className="app-header container">
                <nav className="navbar navbar-expand-lg navbar-dark">
                    <Link className="navbar-brand" to='/'>
                        <img src="../../img/cunum.svg" width="200" height="50" alt="Cunum logo"/>
                    </Link>
                    <button className="navbar-toggler"
                            type="button"
                            data-toggle="collapse"
                            data-target="#navbarSupportedContent"
                            aria-controls="navbarSupportedContent"
                            aria-expanded="false"
                            aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav mr-auto">
                            <li className={this.getClassname('/apps/')}>
                                <Link className="nav-link" to='/apps/'>Mobile Apps</Link>
                            </li>
                            <li className={this.getClassname('/games/')}>
                                <Link className="nav-link" to='/games/'>Games</Link>
                            </li>
                            <li className={this.getClassname('/crypto/')}>
                                <Link className="nav-link" to='/crypto/'>Crypto</Link>
                            </li>
                            <li className={this.getClassname('/opensource/')}>
                                <Link className="nav-link" to='/opensource/'>Open source</Link>
                            </li>
                            <li className={this.getClassname('/contact/')}>
                                <Link className="nav-link" to='/contact/'>Impressum</Link>
                            </li>
                            <li className={this.getClassname('/privacy/')}>
                                <Link className="nav-link" to='/privacy/'>Datenschutz</Link>
                            </li>
                        </ul>
                    </div>
                </nav>
            </header>
        );
    }

    getClassname(route) {
        return route === window.location.pathname ? 'nav-item active' : 'nav-item';
    }
}

export default Header;
